import React, { Component } from 'react';

import style from './TimelineText.module.scss';
import { Observer } from 'react-lazy';

import { CSSPlugin } from 'gsap/CSSPlugin';
import { TweenLite } from 'gsap';

const plugins = [CSSPlugin];

class TimelineText extends Component {
  state = {
    isEntered: false,
  };

  animateInView = () => {
    TweenLite.to(this.itemRef, 1.2, {
      autoAlpha: 1,
      y: '0%',
      ease: Quad.easeInOut,
    });
  };

  handleInView = event => {
    if (event.isIntersecting && !this.state.isEntered) {
      this.setState({ isEntered: !this.state.isEntered }, this.animateInView());
    }
  };

  componentDidMount() {
    TweenLite.set(this.itemRef, { autoAlpha: 0, y: '5%' });
  }
  render() {
    const { body, color_toggle } = this.props;
    return (
      <div ref={el => (this.itemRef = el)} className={style.textWrapper}>
        <Observer onChange={this.handleInView} threshold={[0.66]}>
          <h1
            className={color_toggle ? style.slideshowTitleRed : ''}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </Observer>
      </div>
    );
  }
}

export default TimelineText;



// WEBPACK FOOTER //
// ./src/components/timeline/TimelineText.js